<app-nav titulo="Agentes" descripcion="Aquí podrá ver, editar y borrar todas las cuentas de agentes.">
    <div class="brokers">
        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="brokers"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateBrokers($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
        <button mat-raised-button class="garantor-button add-button" color="primary" routerLink="./nuevo" *ngIf="userType === 'OFICINA'">
            <mat-icon matPrefix class="add-button-icon">add</mat-icon>
            <span class="add-button-label">Nuevo agente</span>
        </button>
    </div>
</app-nav>
<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Cambiar email" class="change-email-row-button" (click)="changeEmail(row)" *ngIf="userType === 'CORPORATIVO'">
            <mat-icon color="primary">alternate_email</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Restablecer contraseña" class="unlock-row-button" (click)="resetUserPassword(row)" *ngIf="userType === 'OFICINA' || userType === 'CORPORATIVO'">
            <mat-icon color="primary">lock_open</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Ver detalles" class="view-more-row-button" [routerLink]="'./' + row.id">
            <mat-icon color="primary">dehaze</mat-icon>
        </button>
        <button mat-icon-button class="edit-row-button" matTooltip="Editar agente" [routerLink]="'./' + row.id + '/editar'" *ngIf="userType === 'OFICINA'">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button class="delete-row-button" matTooltip="Borrar agente" (click)="deleteBroker(row)" *ngIf="userType === 'OFICINA'">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
